module.exports = __webpack_public_path__ + "img/sRoma_350x350.a658676e.jpg";